import React, { ReactNode } from "react";
import ReactDOM from "react-dom/client";
// import'./index.css'
import "./styles/main.css";
import "./styles/color-tokens.css"; // Design token color variables
import "./styles/typography-tokens.css"; // New design token classes

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/query-core";
import { QueryClientProvider } from "@tanstack/react-query";
import { WritableAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { queryClientAtom } from "jotai-tanstack-query";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  googleLoginClientId,
  sentryDns,
  applicationEnvironment,
  sentryTracingOriginHost,
  sentryTracingOriginUrl,
  sentryDesktopTrackingEnable,
} from "common/config";
import AuthModals from "./features/auth/AuthModals";
import "react-toastify/dist/ReactToastify.css";
import { ThemedToastContainer } from "./lib/themed-toast-container";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { usePageCloseTracking } from "./hooks/usePageCloseTracking";

import * as Sentry from "@sentry/react";

if (sentryDesktopTrackingEnable === "Yes") {
  Sentry.init({
    dsn: `${sentryDns}`,
    environment: `${applicationEnvironment}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    tracePropagationTargets: [
      `${sentryTracingOriginHost}`,
      `${sentryTracingOriginUrl}`,
    ],
    // Session Replay
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
  });
}

// Create a new router instance
// @ts-expect-error - Router type mismatch
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

function AtomsHydrator({
  atomValues,
  children,
}: {
  atomValues: Iterable<
    readonly [WritableAtom<unknown, [any], unknown>, unknown]
  >;
  children: ReactNode;
}) {
  useHydrateAtoms(new Map(atomValues));
  return children;
}

function PageCloseTracker() {
  usePageCloseTracking();
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <GoogleOAuthProvider clientId={googleLoginClientId}>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AtomsHydrator atomValues={[[queryClientAtom, queryClient]]}>
          <PageCloseTracker />
          <RouterProvider router={router} />
          <AuthModals />
          <ThemedToastContainer />
        </AtomsHydrator>
      </QueryClientProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>,
);
